import React from 'react'
import { BrowserRouter as Router, Route,Link} from 'react-router-dom'
import { Front,Registration,Vregistration, UserRoutine,
Comment,
Novaturma,
VanRoutine,
User_profile,
Van_Suggestion,
Driver_profile,
} from './index'

export default function navigation(){

    return(
        <Router>
            {/* User */}
            <Route exact path='/' component={Front}/>
            <Route exact path='/user/registration' component={Registration}/>
            <Route exact path='/user/userRoutine' component={UserRoutine}/>
            <Route exact path='/user/userRoutine/comment' component={Comment}/>
            <Route exact path='/user/userRoutine/profile' component={User_profile}/>
            {/* Driver */}
            <Route exact path='/driver/registration' component={Vregistration}/>
            <Route exact path='/driver/vanRoutine' component={VanRoutine}/>
            <Route exact path='/driver/vanRoutine/profile' component={Driver_profile}/>
            <Route exact path='/driver/vanRoutine/comment' component={Van_Suggestion}/>
            <Route exact path='/driver/vanRoutine/novaturma' component={Novaturma}/>
        </Router>
    )
}